import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import $ from '@sparta.global.vendors/jquery';
import cartAjaxUtility from '@sparta.global.utilities/cart-ajax-utility/dist/es5.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es5.js';

/* global spaParams */

// constants
var HLA = 'HLA';
var SUCCESS = 'success';
var FAILURE = 'failure';
var APPLICATION = 'Application';
var REFINANCE_FLOW = 'refinance';
var PREQUAL_FLOW = 'prequal';
var WELCOMEBACK_FLOW = 'welcomeback';
var MORTGAGE_EXPIRY = 30 * 24 * 60 * 60 * 1000; // Prequal same as mortgage, WB DMA conversion
var REFINANCE_EXPIRY = 45 * 24 * 60 * 60 * 1000;
var WELCOMEBACK_EXPIRY = 120 * 24 * 60 * 60 * 1000;
var WELCOMEBACK = 'WELCOMEBACK';
var MORTGAGE = 'MORTGAGE';
var FLOW_SELECTION_CONVERTTODMA = 'CONVERTTODMA';

// variables we remember, from the PROFILE call
var hlSavedApps = [];
var hlSavedProducts = [];
function logToServer(operation, status, appId, savedApplicationId, errorInfo) {
  var logHelperMsg = "DME App ID: ".concat(appId, "; Saved App ID: ").concat(savedApplicationId, "; STATUS: ").concat(status.toUpperCase(), "; # HL apps: ").concat(hlSavedApps.length, "; #HL products: ").concat(hlSavedProducts.length);
  // add
  var appAddedMsgID = "ese-pipad-add-".concat(status);
  var appAddedMsg = "Application adding to shopping cart for ".concat(logHelperMsg);
  // remove
  var appRemoveMsgID = "ese-pipad-remove-".concat(status);
  var appRemoveMsg = "Application removing from shopping cart for ".concat(logHelperMsg);
  var logMsg = operation === 'add' ? appAddedMsg : appRemoveMsg;
  var messageText = errorInfo && errorInfo.length ? "".concat(logMsg, "; PIPAD-ERROR: ").concat(JSON.stringify(errorInfo)) : logMsg;
  var priority = status === SUCCESS ? 'INFO' : 'ERROR';
  var messageId = operation === 'add' ? appAddedMsgID : appRemoveMsgID;
  spartaEventsUtility.pub('log-event', {
    messageId: messageId,
    messageText: messageText,
    priority: priority
  });
}

/**
 * This function makes the AJAX call to update the Unique Product Identifier
 * @param {String} uniqueProductIdentifier The new ID
 * @returns {Object} promise
 */
function getUpdateProductUniqueIdentifier(uniqueProductIdentifier) {
  var _spaParams$siteParams = spaParams.siteParams,
    secureHost = _spaParams$siteParams.secureHost,
    updateUniqueProductIdURL = _spaParams$siteParams.updateUniqueProductIdURL;
  if (uniqueProductIdentifier) {
    var request = {
      url: "".concat(secureHost).concat(updateUniqueProductIdURL, "?uniqueProductIdentifier=").concat(uniqueProductIdentifier),
      async: true,
      dataType: 'JSON',
      type: 'GET',
      contentType: 'application/json; charset=utf-8',
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      }
    };
    $.ajax(_objectSpread({}, request));
  }
}

/**
 * Makes a request to the update unique product id endpoint
 * @param {Object} productUniqueIdentifier productUniqueID returned from add()
 * @returns {void}
 */
function updateUniqueProductIdentifier() {
  var productUniqueIdentifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  if (productUniqueIdentifier) {
    getUpdateProductUniqueIdentifier(productUniqueIdentifier);
  }
}

/**
 * Remember the payload
 * @param {Object} payload the shopping cart
 */
function updateTheSavedDetails(payload) {
  hlSavedApps = [];
  hlSavedProducts = [];

  // adding a null check because, remove call sometimes won't return the cartdetails.
  if (!payload) return;
  var shoppingCart = payload.shoppingCart;
  // the apps
  var savedApps = shoppingCart && shoppingCart.savedApps ? shoppingCart.savedApps : null;
  if (savedApps) {
    // add applications whose item type is application and product type hla items
    savedApps.forEach(function (app) {
      var savedApp = app.savedApp ? app.savedApp : {};
      var cartProductType = savedApp.cartProductType;
      var isHLA = cartProductType && cartProductType.toLowerCase() === HLA.toLowerCase();
      if (isHLA) {
        hlSavedApps.push(savedApp);
      }
    });
  }
  // the products
  var products = shoppingCart && shoppingCart.products ? shoppingCart.products : null;
  if (products) {
    products.forEach(function (productItem) {
      var product = productItem.product ? productItem.product : {};
      var cartProductType = product.cartProductType;
      var isHLA = cartProductType ? cartProductType.toLowerCase() === HLA.toLowerCase() : false;
      if (isHLA) {
        hlSavedProducts.push(product);
      }
    });
  }
}

/**
 * Retrieve cart call
 */
function getTheCart() {
  return cartAjaxUtility.retrieve().then(function (payload) {
    updateTheSavedDetails(payload.cartDetails);
    return Promise.resolve(payload.cartDetails);
  }).catch(function (e) {
    console.error("Error in retrieve call, Error: ".concat(e));
    return Promise.reject(e);
  });
}

/**
 * checks if current app is added to the cart
 * @param {String} savedApplicationId DMA AppId
 */
function checkIfAppExists(savedApplicationId) {
  if (savedApplicationId && hlSavedApps && hlSavedApps.length) {
    // find application with savedApplicationId
    var savedAppPayload = hlSavedApps.find(function (savedApp) {
      var productIdentifier = savedApp.productIdentifier;
      var savedAppId = productIdentifier && productIdentifier.savedAppId ? productIdentifier.savedAppId : '';
      return savedAppId.toLowerCase() === savedApplicationId.toLowerCase();
    });
    return savedAppPayload;
  }
  return null;
}

/**
 * makes get call to signoff - return promise but most likely will be fire and forget
 * @returns {Promise}
 */
function signOff() {
  return new Promise(function (resolve, reject) {
    cartAjaxUtility.getSignOff().then(function () {
      resolve(SUCCESS);
    }).catch(function (e) {
      console.error("Signoff failed with Error: ".concat(e));
      reject();
    });
  });
}

/**
 * extract the pathname from absolute URL
 * @param {String} url url to strip the hostname
 */
function extractPath(url) {
  var anchorTag = document.createElement('a');
  anchorTag.href = url;
  var imagePath = anchorTag.pathname;
  if (imagePath.charAt(0) !== '/') {
    imagePath = "/".concat(imagePath);
  }
  return imagePath;
}

/**
 * add the app to the cart if not added
 * @param {String} appId DMA AppId
 * @param {String} savedApplicationId DMA savedApplicationId
 */
function addAppToCart(appId, savedApplicationId, payload, productUniqueIdentifier) {
  var savedAppPayload = checkIfAppExists(savedApplicationId);
  // already in the cart, ignore
  if (savedAppPayload) {
    return Promise.resolve(SUCCESS);
  }
  var flowName = spaParams.pageParams.flowName;
  var appPayload = JSON.parse(JSON.stringify(payload));
  appPayload.savedApp.productIdentifier.savedAppId = savedApplicationId;

  // update the productUniqueIdentifier of the customer journey
  // BE gets it in the enrichment and is passed on all routes
  if (productUniqueIdentifier) {
    appPayload.savedApp.productUniqueIdentifier = productUniqueIdentifier;
  }

  // update the savedAppExpiryDate
  var today = new Date().getTime();
  var savedAppExpiryDate = today + MORTGAGE_EXPIRY;
  if (flowName === REFINANCE_FLOW) {
    savedAppExpiryDate = today + REFINANCE_EXPIRY;
  } else if (flowName === WELCOMEBACK_FLOW) {
    // skipping 120 exipry, if we are adding wb dma conversion app into cart
    // so it can take default which is mortgage
    if (appPayload.savedApp.productCartContent.productName.toUpperCase() !== MORTGAGE) {
      savedAppExpiryDate = today + WELCOMEBACK_EXPIRY;
    }
  } else if (flowName === PREQUAL_FLOW) {
    // In prequal flow we want to add wb app on prequal approved page
    if (appPayload.savedApp.productIdentifier.productSubType.toLowerCase() === WELCOMEBACK_FLOW) {
      savedAppExpiryDate = today + WELCOMEBACK_EXPIRY;
    }
  }
  appPayload.savedApp.productCartContent.savedAppExpiryDate = savedAppExpiryDate;

  // strip the hostname from image
  var landingPageImage = appPayload.savedApp.productCartContent.landingPageImage;
  appPayload.savedApp.productCartContent.landingPageImage = extractPath(landingPageImage);

  // call to add
  var promise = new Promise(function (resolve, reject) {
    cartAjaxUtility.add(appPayload).then(function (res) {
      if (res.status && res.status.toLowerCase() === SUCCESS) {
        updateTheSavedDetails(res.cartDetails);
        updateUniqueProductIdentifier(res.productUniqueIdentifier);
        logToServer('add', SUCCESS, appId, savedApplicationId);
        resolve(SUCCESS);
      } else {
        var errorInfo = res.errorInfo && res.errorInfo.length ? res.errorInfo : null;
        logToServer('add', FAILURE, appId, savedApplicationId, errorInfo);
        resolve(FAILURE);
      }
    }).catch(function (e) {
      logToServer('add', FAILURE, appId, savedApplicationId);
      console.error("Error adding ".concat(flowName, " apllication, Error: ").concat(e));
      reject();
    });
  });
  return promise;
}

/**
 * get the Product Unique Identifier from the savedAppID if app is found else return null.
 * @param {String} savedAppId DMA app ID
 * @returns {String} if there is a matching app found then it will return the
 * productUniqueIdentifier from that app, or if no matching app is found it will return null.
 */
function getProductUniqueIdentifier(savedAppId) {
  var appProductUniqueIdentifier = null;
  if (savedAppId && hlSavedApps && hlSavedApps.length) {
    var matchingApp = hlSavedApps.find(function (app) {
      return app.productIdentifier && app.productIdentifier.savedAppId === savedAppId;
    });
    if (matchingApp) {
      return matchingApp.productUniqueIdentifier;
    }
  }
  return appProductUniqueIdentifier;
}

/**
 * removes the app from the cart
 * @param {String} appId DMA AppId
 * @param {String} savedApplicationId DMA savedApplicationId AppId
 */
function removeSavedApplicationFromCart(appId, savedApplicationId) {
  var savedApp = checkIfAppExists(savedApplicationId);
  // make call to remove application from cart
  if (savedApp) {
    var savedAppPayload = {
      cartItemType: APPLICATION,
      savedApp: _objectSpread({}, savedApp)
    };
    return new Promise(function (resolve, reject) {
      cartAjaxUtility.remove(savedAppPayload).then(function (res) {
        if (res.status && res.status.toLowerCase() === SUCCESS) {
          updateTheSavedDetails(res.cartDetails);
          logToServer('remove', SUCCESS, appId, savedApplicationId);
          resolve(SUCCESS);
        } else {
          var errorInfo = res.errorInfo && res.errorInfo.length ? res.errorInfo : null;
          logToServer('remove', FAILURE, appId, savedApplicationId, errorInfo);
          resolve(FAILURE);
        }
      }).catch(function (e) {
        logToServer('remove', FAILURE, appId, savedApplicationId);
        var flowName = spaParams.pageParams.flowName;
        console.error("Error removing ".concat(flowName, " apllication, Error: ").concat(e));
        reject();
      });
    });
  }
  return Promise.resolve(SUCCESS);
}

/**
 * Find and remove welcomeback cart items
 */
function findAndRemoveWelcomeBackAppFromCart() {
  var savedApplicationId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var wbFlowSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var targetSavedApplicationId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (hlSavedApps && hlSavedApps.length) {
    // find all wb saved apps
    var wbSavedApps = hlSavedApps.filter(function (savedApp) {
      var productIdentifier = savedApp.productIdentifier;
      return productIdentifier.productSubType.toLowerCase() === WELCOMEBACK.toLowerCase();
    });

    // if we don't have any welcomeback app, don't continue from here
    if (wbSavedApps.length < 1) {
      return Promise.resolve(SUCCESS);
    }

    // removing wb saved apps
    var promiseAll = Promise.all(wbSavedApps.map(function (wbSavedApp) {
      var savedAppId = wbSavedApp.productIdentifier.savedAppId;

      // here before deleting wb application
      // checking that application is same or not
      // becuase don't want to delete and adding wb app of same app id on
      // refresh of any confirmation page or
      // every save and exit page of dma conversion or
      // user refresh/go back and come again on dma conversion flow
      var isSameAppId = savedApplicationId && savedApplicationId === savedAppId;
      var isSameWbDmaAppId = false;
      if (isSameAppId && wbFlowSelection === FLOW_SELECTION_CONVERTTODMA) {
        var productName = wbSavedApp.productCartContent.productName;
        isSameWbDmaAppId = isSameAppId && productName && MORTGAGE === productName.toUpperCase();
        // only for wb dma conversion, this is hack for below if condition gets true/false
        isSameAppId = isSameWbDmaAppId;
      }
      if (isSameAppId || isSameWbDmaAppId) {
        return Promise.resolve(SUCCESS);
      }
      if (targetSavedApplicationId && targetSavedApplicationId === savedAppId) {
        return Promise.resolve(SUCCESS);
      }
      var removeItemPromise = removeSavedApplicationFromCart('', savedAppId);
      removeItemPromise.catch(function (e) {
        logToServer('remove', FAILURE, '', savedAppId);
        var flowName = spaParams.pageParams.flowName;
        // eslint-disable-next-line no-console
        console.error("Error removing ".concat(flowName, " apllication, Error: ").concat(e));
      });
      return removeItemPromise;
    }));
    return promiseAll;
  }
  return Promise.resolve(SUCCESS);
}

/**
 * get the barker count/number of items in the cart
 * @returns {Promise<Number>} Promise to the number of items.
 */
function getNumberOfItemsInCart() {
  var barkerCountPromise = cartAjaxUtility.retrieve();
  var returnPromise = new Promise(function (resolve) {
    barkerCountPromise.then(function (payload) {
      resolve(payload.barkerCount);
    }).catch(function () {
      resolve(-1);
    });
  });
  return returnPromise;
}
var index = {
  addAppToCart: addAppToCart,
  removeSavedApplicationFromCart: removeSavedApplicationFromCart,
  getNumberOfItemsInCart: getNumberOfItemsInCart,
  signOff: signOff,
  findAndRemoveWelcomeBackAppFromCart: findAndRemoveWelcomeBackAppFromCart,
  getTheCart: getTheCart,
  getProductUniqueIdentifier: getProductUniqueIdentifier,
  updateUniqueProductIdentifier: updateUniqueProductIdentifier
};
export { index as default };